import DpForm from 'javascripts/classes/ajaxforms';

const tpl = require('./faq-overview.njk');

const wrapper = document.querySelectorAll('.faq-overview')[0];

const urlString = window.top === window ? window.location.href : document.referrer;
const query = new URL(urlString).searchParams.get('faq_query');

if (wrapper) {
  const options = {
    fields: {
      wrapper,
      search: wrapper.querySelectorAll('input[name="faq-search"]')[0],
      searchButton: wrapper.querySelectorAll('button.search-input__icon')[0],
      topics: wrapper.querySelectorAll('select[name="faq-subjects"]')[0],
      sort: false,
      error: wrapper.querySelectorAll('.alert')[0],
      results: wrapper.querySelectorAll('.faq')[0],
    },
    loadMore: {
      steps: wrapper.dataset.steps || 15,
      buttonSelector: '.faq__button .button',
      itemsContainerSelector: '.faq',
    },
    showCount: 1,
    mode: wrapper.dataset.mode,
    type: 'faq',
    query,
    tpl,
    labels: {
      minutes_and_duration: 'Minuten Lesedauer',
      topics_all: 'Alle Kategorien',
      no_results: 'Keine Ergebnisse gefunden',
    },
    urlPrefix: 'data/ratgeber/',
    strapi: { url: wrapper.dataset['strapi-url'], publicationState: 'preview' },

  };
  if (options.fields.search) {
    const form = new DpForm(options);
    form.init();
  }
}
